'use strict';

module.exports = require('./compile/runtime');


//////////////////
// WEBPACK FOOTER
// /usr/local/src/vipp-cli/~/yyvip-art-template/lib/runtime.js
// module id = 20
// module chunks = 0